export const formatApolloErrorMessages = (message: string) => {
  switch (message) {
    case "Network error: Failed to fetch":
      return { type: "Netværksfejl", message: "Kunne ikke kontakte serveren" };

    default:
      return { type: message, message: "" };
  }
};
